import axios from "axios"
import Cookies from 'js-cookie';

const BaseURL = import.meta.env.VITE_BASEURL;

// /check/token
export const CheckToken = async () => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(`${BaseURL}/check/token`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
}